import { Navigate, Outlet } from "react-router-dom";
import { getSession } from "../utils/session";

// The actual credential is an HttpOnly cookie the browser carries silently.
// We can't read it, so we gate on the user-identity snapshot we saved at login.
// If the cookie is missing/expired, the next API call returns 401 and the
// axios interceptor wipes the session and redirects here.
const ProtectedRoute = () => {
  const session = getSession();
  return session ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
